import { useTheme, Theme } from '@mui/material/styles';
import React from 'react';
import {
  DragDropContext,
  DraggableLocation,
  Droppable,
  DroppableProvided,
  DropResult,
} from 'react-beautiful-dnd';

interface IProps {
  id: string;
  onDrop?: (props: {
    source: DraggableLocation;
    destination: DraggableLocation;
  }) => unknown;
  children: React.ReactNode;
}

interface IProvidedProps extends Pick<DroppableProvided, 'droppableProps'> {
  innerRef: DroppableProvided['innerRef'];
  [x: string]: any;
}

export const withDroppable = (
  WrappedComponent: React.ComponentType<IProps & Partial<IProvidedProps>>
) => {
  // Cast components to any to bypass TypeScript errors
  const DragDropContextAny = DragDropContext as any;
  const DroppableAny = Droppable as any;
  
  const WithDroppable = ({
    id,
    onDrop,
    children,
    ...props
  }: IProps & Partial<IProvidedProps>) => {
    const theme = useTheme<Theme>();

    const handleDragEnd = async ({ source, destination }: DropResult) => {
      if (!destination) {
        return;
      }

      if (typeof onDrop === 'function') {
        onDrop({ source, destination });
      }
    };

    return (

    //   <DragDropContext onDragEnd={handleDragEnd}>
    //   <Droppable droppableId={id}>
    //     {(provided, snapshot) => (
    //       <WrappedComponent
    //         id={id}
    //         innerRef={provided.innerRef}
    //         style={
    //           snapshot.isDraggingOver
    //             ? { background: theme.palette.grey[300] }
    //             : {}
    //         }
    //         {...provided.droppableProps}
    //         {...props}
    //       >
    //         {children}
    //         {provided.placeholder}
    //       </WrappedComponent>
    //     )}
    //   </Droppable>
    // </DragDropContext>

    //New version
      <DragDropContextAny onDragEnd={handleDragEnd}>
        <DroppableAny droppableId={id}>
          {(provided: any, snapshot: any) => {
            const placeholderAny = provided.placeholder as any;
            return (
              <WrappedComponent
                id={id}
                ref={provided.innerRef}
                style={
                  snapshot.isDraggingOver
                    ? { background: theme.palette.grey[300] }
                    : {}
                }
                {...provided.droppableProps}
                {...props}
              >
                {children}
                {placeholderAny}
              </WrappedComponent>
            );
          }}
        </DroppableAny>
      </DragDropContextAny>
    );
  };

  return WithDroppable;
};